module.exports = __webpack_public_path__ + "static/img/left-bottom-row-2.33b73c1e.png";